import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function InsomniaTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['insomnia-testi']} />;
}
